import { Modal, Form, Input, Button } from "antd";
import { useState } from "react";

const { TextArea } = Input;

const MarkAsLostModal = ({
  draggableLead,
  updateLead,
  status,
  setStatus,
  handleCancel,
}) => {
  const [visible, setVisible] = useState();

  const onCancel = () => {
    setVisible(false);
    setStatus();
    handleCancel();
  };

  return (
    <>
      <div
        className={`float-lead-btn float-button-lost ${status === "lost" ? "drag-over-lost" : ""}`}
        onDragOver={(e) => {
          setStatus("lost");
          e.preventDefault();
        }}
        onDragLeave={() => setStatus()}
        onDrop={(e) => {
          setVisible(true);
          e.preventDefault();
        }}
      >
        <div className="d-flex align-items-center gap-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27.603"
            height="28.759"
            viewBox="0 0 27.603 28.759"
          >
            <g id="_x36_7" transform="translate(-11.193 -10.092)">
              <path
                id="Path_817"
                data-name="Path 817"
                d="M19.788,26.473c2.906,3.033,7.539,3.118,10.12.067A6.889,6.889,0,0,0,31.269,19.9c-1.6-4.578-5.758-6.285-8.7-5.008A7.058,7.058,0,0,0,19.788,26.473Zm3.081-10.856a4.638,4.638,0,0,1,1.386-.342c.057.018,3.182-.441,5.445,3.168a7.993,7.993,0,0,1,.825,1.709,6.111,6.111,0,0,1-1.547,6.227c-3.234,3.209-8.648,1.35-10.085-2.853A6.341,6.341,0,0,1,22.868,15.617Z"
                transform="translate(-3.135 -2.084)"
                fill="currentColor"
              />
              <path
                id="Path_818"
                data-name="Path 818"
                d="M29.122,25.121a1.013,1.013,0,0,1,.752,1.721.906.906,0,0,1-1.032.259,1.123,1.123,0,0,1-.7-.978.394.394,0,0,0-.393-.389h0a.394.394,0,0,0-.389.4,1.891,1.891,0,0,0,1.405,1.761l.006.489a.394.394,0,0,0,.393.389h0a.394.394,0,0,0,.389-.4l-.005-.467a1.817,1.817,0,0,0,1.285-2.423,1.909,1.909,0,0,0-1.7-1.15h-.014a1.088,1.088,0,0,1-1-.532,1.167,1.167,0,0,1,.262-1.205l.006-.007a.8.8,0,0,1,.93-.225,1.141,1.141,0,0,1,.772.966.394.394,0,0,0,.393.389h0a.394.394,0,0,0,.389-.4,1.9,1.9,0,0,0-1.4-1.728l0-.352a.394.394,0,0,0-.393-.389h0a.394.394,0,0,0-.389.4l0,.3a1.561,1.561,0,0,0-.918.553,1.758,1.758,0,0,0,1.353,3.02Z"
                transform="translate(-7.632 -5.115)"
                fill="currentColor"
              />
              <path
                id="Path_819"
                data-name="Path 819"
                d="M36.408,28.891l.534.011h.008a.394.394,0,0,0,.008-.787l-.534-.011a.381.381,0,0,0-.4.386A.394.394,0,0,0,36.408,28.891Z"
                transform="translate(-11.802 -8.562)"
                fill="currentColor"
              />
              <path
                id="Path_820"
                data-name="Path 820"
                d="M23.574,28.529l.542.011a.394.394,0,0,0,.008-.787l-.534-.011a.413.413,0,0,0-.4.386A.394.394,0,0,0,23.574,28.529Z"
                transform="translate(-5.702 -8.39)"
                fill="currentColor"
              />
              <path
                id="Path_821"
                data-name="Path 821"
                d="M38.2,25.513a1.615,1.615,0,0,0-.591-1.249.4.4,0,0,0-.169-.074,5.771,5.771,0,0,0-1.681-.122,1.987,1.987,0,0,0-1.428.776,2.183,2.183,0,0,0-1.177-.375H29.515a9,9,0,0,0,.72-7.207c-1.931-5.548-7.053-8.291-11.173-6.744a.461.461,0,0,0-.126.043,11.425,11.425,0,0,0-1.945.946A9.3,9.3,0,0,0,13.83,26.595a9.411,9.411,0,0,0,9.147,2.766,8.5,8.5,0,0,0,2.24-.995,2.074,2.074,0,0,0,.379,1.775l0,0A1.934,1.934,0,0,0,24.962,32a1.885,1.885,0,0,0,1.352,1.393c.1.025-.115.009,3.906.013a4.292,4.292,0,0,0-.5,4.109c.811,1.584,2.776,1.686,3.363.7a2.018,2.018,0,0,0,.172-1.206,5.324,5.324,0,0,1,1.11-3.467c.2-.246.439-.5.653-.756a2.573,2.573,0,0,0,1.634.566,2.174,2.174,0,0,0,2.061-1.45C38.893,31.284,38.816,31.14,38.2,25.513ZM19.054,11.369a6.352,6.352,0,0,1,1.907-.472c.109.034,4.324-.6,7.413,4.308a10.65,10.65,0,0,1,1.117,2.317,8.247,8.247,0,0,1-.882,6.947l-1.1,0A1.647,1.647,0,0,0,26.1,25.732a1.854,1.854,0,0,0,.134,1.2c-4.67,3.069-10.862.22-12.569-4.806a8.634,8.634,0,0,1,5.391-10.759ZM33.745,33.052a6.123,6.123,0,0,0-1.279,3.991,1.545,1.545,0,0,1-.061.767c-.257.431-1.457.382-1.987-.656a2.76,2.76,0,0,1-.122-1.969,7.433,7.433,0,0,1,.955-1.964.394.394,0,0,0-.306-.6c-.08-.006-4.42,0-4.472,0a1.1,1.1,0,0,1-.742-.786,1.146,1.146,0,0,1,.368-1.084c.311-.263.784-.216,2.191-.3l-.041-.786a15.491,15.491,0,0,0-1.88.13,1.237,1.237,0,0,1-.4-1.2,1.251,1.251,0,0,1,.9-1.007,3.4,3.4,0,0,0,1.517.267.394.394,0,0,0,.371-.414.411.411,0,0,0-.414-.371,2.333,2.333,0,0,1-1.184-.219.913.913,0,0,1-.3-.935.871.871,0,0,1,.676-.662h5.614a1.461,1.461,0,0,1,.925.372c-.021.312-.016.166.4,6.205a1.187,1.187,0,0,0,.06.282C34.24,32.5,34.023,32.7,33.745,33.052Z"
                transform="translate(0 0)"
                fill="currentColor"
              />
              <path
                id="Path_822"
                data-name="Path 822"
                d="M52.876,24.963a.828.828,0,0,0,1.309.012l1.768-2.233h0A.829.829,0,0,0,55.3,21.4h-.461V19.228a.57.57,0,0,0-.567-.572H52.885a.573.573,0,0,0-.572.572V21.4h-.46a.829.829,0,0,0-.664,1.325C51.693,23.395,52.442,24.393,52.876,24.963Zm.224-5.52h.955V21.4H53.1Zm-1.247,2.742,3.488.024a.039.039,0,0,1,0,.045L53.5,24.486c-.433-.569-1.181-1.565-1.684-2.236Z"
                transform="translate(-18.933 -4.071)"
                fill="currentColor"
              />
              <path
                id="Path_823"
                data-name="Path 823"
                d="M27.151,52.179H26.69V50.009a.57.57,0,0,0-.567-.572h-1.39a.573.573,0,0,0-.572.572v2.169H23.7a.829.829,0,0,0-.663,1.326c.5.672,1.253,1.669,1.687,2.239a.828.828,0,0,0,1.309.012L27.8,53.522A.829.829,0,0,0,27.151,52.179Zm-2.2-1.955H25.9v1.955h-.954Zm2.235,2.81-1.768,2.233H25.35c-.432-.569-1.18-1.564-1.684-2.235l.034-.067,3.488.024A.037.037,0,0,1,27.184,53.034Z"
                transform="translate(-5.55 -18.703)"
                fill="currentColor"
              />
            </g>
          </svg>
          LOST
        </div>
      </div>
      <Modal
        title={
          <div className="heading24px text-color-1C1C1C roboto-medium">
            Mark Lead as Lost
          </div>
        }
        open={visible}
        onCancel={() => {
          onCancel();
        }}
        footer={<></>}
      >
        <span className="cursor-pointer">
          <b>Lead Name:</b> {draggableLead?.fullname}
        </span>

        <MarkAsLost
          onSubmit={(value) => {
            updateLead({
              ...draggableLead,
              ...value,
              status: 17,
            });
            onCancel();
          }}
          handleCancel={onCancel}
        />
      </Modal>
    </>
  );
};

export default MarkAsLostModal;

const MarkAsLost = ({ onSubmit, handleCancel }) => {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      layout="vertical"
      className="mt20"
      onFinish={(values) => {
        onSubmit(values);
        form.resetFields();
      }}
    >
      <Form.Item
        name="lostReason"
        label="Lost Reason"
        rules={[{ required: true, message: "Please add a reason" }]}
      >
        <Input className="common-input" placeholder="Enter reason" />
      </Form.Item>

      <Form.Item name="comments" label="Comments">
        <TextArea
          className="common-input"
          rows={3}
          placeholder="Enter comments"
        />
      </Form.Item>
      <div
        className="mt40 d-flex justify-content-end align-items-center"
        style={{ gap: 20 }}
      >
        <Button
          onClick={() => {
            handleCancel();
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button type="primary" className="stop-sync" htmlType="submit">
          Mark as lost
        </Button>
      </div>
    </Form>
  );
};
